import fetch from "auth/FetchInterceptor";
import { API_BASE_URL } from "configs/AppConfig";

const IntegrationService = {};

IntegrationService.getIntegration = function () {
  return fetch({
    url: `${API_BASE_URL}/Integration/usuario`,
    method: "get",
    headers: {
      "Content-Type": "application/json",
    },
  });
};

IntegrationService.createIntegration = function (data) {
  return fetch({
    url: `${API_BASE_URL}/Integration`,
    method: "post",
    headers: {
      "Content-Type": "application/json",
    },
    data,
  });
};

IntegrationService.updateIntegration = function (id, data) {
  return fetch({
    url: `${API_BASE_URL}/Integration/${id}`,
    method: "put",
    headers: {
      "Content-Type": "application/json",
    },
    data,
  });
};

IntegrationService.deleteIntegration = function (id) {
  return fetch({
    url: `${API_BASE_URL}/Integration/${id}`,
    method: "delete",
    headers: {
      "Content-Type": "application/json",
    },
  });
};

export default IntegrationService;
